import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
    label: {
        display: 'block',
        marginBottom: 6,
        marginTop: 16,
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        fontSize: 12,
        color: 'black',
    },
    input: {
        width: '100%',
        padding: 10,
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        fontSize: 12,
        color: theme.colors.light.darkgrey,
        borderRadius: 2,
        borderStyle: 'solid',
        border: 1,
        borderColor: theme.colors.light.grey,
    },

    select: {
        fontSize: 12,
        fontFamily: theme.typographyPresets.fonts.notoSans.regular,
        color: theme.colors.light.darkgrey,

        '& span': {
            lineHeight: 2,
        },

        '& input': {
            fontFamily: theme.typographyPresets.fonts.notoSans.bold,
            fontSize: 12,
            marginLeft: 0,

            '&::placeholder': {
                /* Chrome, Firefox, Opera, Safari 10.1+ */
                fontFamily: theme.typographyPresets.fonts.notoSans.regular,
                fontSize: 12,
                color: 'black',
                opacity: 1 /* Firefox */,
            },

            '&:-ms-input-placeholder': {
                /* Internet Explorer 10-11 */
                fontFamily: theme.typographyPresets.fonts.notoSans.regular,
                fontSize: 12,
                color: 'black',
            },

            '&::-ms-input-placeholder': {
                /* Microsoft Edge */
                fontFamily: theme.typographyPresets.fonts.notoSans.regular,
                fontSize: 12,
                color: 'black',
            },
        },

        '& svg': {
            verticalAlign: 'unset',
        },
    },
    error: {
        ...theme.typographyPresets.labelPrimary,
        color: 'red',
        margin: '10px 2px',
    },
}))
